import types from './types';
import { constants as modes } from './constants';

export const initialState = () => ({
    faces: null,
    notReady: true,
    isInitialized: false,
    step: modes.CHOICE_MODE,
    isLoading: false,
    selectedShade: null,
    isLibError: false,
    isError: false,
});

const mapFaces = (data = []) =>
    data.map(({ uid, modelMedia = {} }) => ({
        uid,
        thumbnail: modelMedia.grid && modelMedia.grid.url,
        original: modelMedia.beforeafter && modelMedia.beforeafter.url,
    }));

const reducers = (state = initialState(), action) => {
    const { payload } = action;

    switch (action.type) {
        case types.SET_FACES:
            return { ...state, faces: mapFaces(payload) };

        case types.START_MODE:
            return {
                ...state,
                ...(payload.mode === modes.LIVE_MODE || payload.mode === modes.PHOTO_MODE
                    ? { isLoading: true }
                    : {}),
                step: payload.mode,
                faceId: payload.faceId,
                isError: false,
            };

        case types.SET_LOADING:
            return { ...state, isLoading: payload };

        case types.SET_MAKEUP_PRODUCT_DATA:
            return { ...state, makeupProductData: payload };

        case types.SET_LIBRARY_INITIALIZED:
            return {
                ...state,
                isInitialized: true,
                notReady: false,
            };

        case types.SET_CURRENT_SHADE:
            return { ...state, selectedShade: payload };

        case types.MODIFACE_ERROR:
            return { ...state, isError: true };

        case types.RESET_MODIFACE_ERROR:
            return { ...state, isError: false, isLibError: false, error: null };

        case types.LIBRARY_ERROR:
            return { ...state, isLibError: true };

        case types.ON_SHADE_TOGGLE:
            return { ...state, isShadeActive: !state.isShadeActive };

        default:
            return state;
    }
};

export default reducers;
